module.exports = __webpack_public_path__ + "static/presidents-message-small-thumbnails-rect-250x125-63cc72648cc63ce4238a91b58f71ba40.jpg";